import React from "react";
import { Button, Check, Eye } from "@opendate-app/setlist";
import { benefitTextForFans, validLogins, visibleBenefits } from "./membershipFormLogic";

export const dollars = (cents) => `$${(cents / 100).toFixed(2).replace(/\.00$/, "")}`;

export const priceLine = (product, { annualEnabled, monthlyEnabled }) => {
  const annual = annualEnabled && product.default_price && product.default_price.amount_cents;
  const monthly = monthlyEnabled && product.default_monthly_price && product.default_monthly_price.amount_cents;
  return [annual ? `${dollars(annual)}/year` : null, monthly ? `${dollars(monthly)}/month` : null].filter(Boolean).join(" or ");
};

const FanPreview = ({ teamName, product, imageUrl, enabled, onPreviewWidget, children }) => {
  const benefits = visibleBenefits(product).filter((b) => b.description && b.description.trim());
  const price = [
    priceLine(product, { annualEnabled: enabled.annual, monthlyEnabled: enabled.monthly }),
    product.household ? ["Household", validLogins(product.household_logins) ? `${product.household_logins} logins` : null].filter(Boolean).join(" · ") : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <aside className="membership-preview" aria-label="Fan preview">
      <span className="membership-eyebrow">Fan preview</span>
      <div className="membership-preview-card" data-testid="membership-fan-preview">
        {imageUrl ? <img className="membership-preview-image" src={imageUrl} alt="" /> : null}
        <div className="membership-preview-hero">
          <span className="membership-preview-team">{teamName}</span>
          <span className="membership-preview-name">{product.name || "Untitled membership"}</span>
          {price ? <span className="membership-preview-price">{price}</span> : null}
        </div>
        <ul className="membership-preview-benefits">
          {benefits.length ? (
            benefits.map((b) => (
              <li key={b.id || b._tempId}>
                <Check width={16} height={16} aria-hidden="true" />
                <span>{benefitTextForFans(b)}</span>
              </li>
            ))
          ) : (
            <li className="membership-hint">No benefits yet.</li>
          )}
        </ul>
        <div className="membership-preview-foot">
          <span className="membership-preview-join" aria-hidden="true">
            Join
          </span>
        </div>
      </div>
      {onPreviewWidget ? (
        <>
          <Button variant="secondary" icon={Eye} onClick={onPreviewWidget}>
            Preview widget
          </Button>
          <span className="membership-hint">Opens the real widget, with desktop and mobile views.</span>
        </>
      ) : null}
      {children}
    </aside>
  );
};

export default FanPreview;
